import { Avatar, Box, Divider, Grid, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { selectSchoolInsUpd } from "../../../redux/school/schoolInsUpdSlice";
import { assertImagesUrl, getImageProcessorStyleName } from "../../../redux/common";

export function SchoolInsUpdReview() {
    const schoolInsUpd = useSelector(selectSchoolInsUpd);

    return <>
        <Typography variant="h6" gutterBottom>
            Revisão
        </Typography>
        <Grid container spacing={3}>
            <Grid size={2}>
                <Typography component="div" variant="body1" color="darkgray" align="right">Nome</Typography>
            </Grid>
            <Grid size={10}>
                <Typography component="div" variant="body1" color="darkblue">{schoolInsUpd.school.name}</Typography>
            </Grid>
            <Grid size={2}>
                <Typography component="div" variant="body1" color="darkgray" align="right">Imagem</Typography>
                <Divider flexItem />
            </Grid>
            <Grid size={10}>
                <Typography component="div" variant="body1" color="darkblue">
                    { getImageProcessorStyleName( schoolInsUpd.school.imageProcessorStyle ) }
                </Typography>
                <Divider flexItem />
            </Grid>
            <Grid size={10}>
                <Box sx={{ display: "flex", alignItems: "center", m: 1 }}>
                    <Avatar
                        src={assertImagesUrl(schoolInsUpd.school.url)}
                        alt={schoolInsUpd.school.name}
                        sx={{ width: 60, height: 60, border: "1px solid #ccc" }}
                    />
                </Box>
            </Grid>
        </Grid>
        <Divider flexItem />
    </>;
}